export default function () {
  [...document.querySelectorAll(".js-framework")].forEach((el) => {
    const container = el.querySelector(".js-framework-container");
    const items = el.querySelectorAll(".js-framework-item");

    const editorView = document.querySelector(".is-page-editor");

    let isDesktop = window.matchMedia("(min-width: 1230px)").matches;

    const toggleItem = (item, isOpen = false) => {
      const itemContent = item.querySelector(".js-framework-item-content");
      item.classList.toggle("is-open", isOpen);

      requestAnimationFrame(() => {
        const contentHeight = itemContent.scrollHeight;
        if (!editorView) {
          itemContent.style.maxHeight = isOpen ? `${contentHeight}px` : 0;
        }
      });

      itemContent.setAttribute("aria-hidden", !isOpen);
      item.setAttribute("aria-expanded", isOpen);
    };

    // Runs only on initial load and resize
    const resizeBorder = () => {
      const firstItem = el.querySelectorAll(".js-framework-item-btn")[0];

      // Resize border relative to 1st item if present
      if (firstItem) {
        const firstItemPos = firstItem.offsetTop;
        const firstItemHeight = firstItem.scrollHeight;

        container.style.setProperty(
          "--border-height",
          `${firstItemPos + firstItemHeight / 2}px`,
        );
      } else {
        container.style.setProperty("--border-height", "100%");
      }
    };

    // if in Experience Editor open accordions and then exit.
    if (editorView) {
      [...items].forEach((item) => {
        toggleItem(item, true);
      });

      return;
    }

    const resetToDefault = () => {
      [...items].forEach((item, idx) => {
        if (idx === 1) {
          toggleItem(item, true);
        } else {
          toggleItem(item);
        }
      });
    };

    resetToDefault();

    // Click handlers
    [...items].forEach((item, idx) => {
      const itemButton = item.querySelector(".js-framework-item-btn");

      itemButton.addEventListener("click", (e) => {
        const isFirst = idx === 0;

        const activeElements = el.querySelectorAll(".is-open");
        const activeEl =
          activeElements.length > 1 ? activeElements[1] : activeElements[0];

        if (isDesktop) {
          // Close other open items except when clicking first item
          if (!isFirst) {
            toggleItem(activeEl);
            toggleItem(item, true);
          }

          // When 1st item is expanded, the expanded items before it will remain expanded
          else if (isFirst) {
            item.classList.contains("is-open")
              ? toggleItem(item)
              : toggleItem(item, true);
          }
        } else {
          if (activeEl) {
            toggleItem(activeEl);
          }

          toggleItem(item, true);
        }
      });
    });

    window.addEventListener("resize", () => {
      isDesktop = window.matchMedia("(min-width: 1230px)").matches;

      requestAnimationFrame(() => {
        // Close all items and open second on resize
        resetToDefault();

        setTimeout(() => resizeBorder(), 300);
      });
    });

    requestAnimationFrame(() => resizeBorder());
  });
}
